import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      value: null
    };
  },

  methods: {
    getAction(event, action) {
      if (action === 'view') {
        this.params.context.componentParent.showleaddetail(this.params.data.lead_id);
      } else if (action === 'delete') {
        this.params.context.componentParent.confirmModalOpen('delete', this.params.data.lead_id);
      }
    }
  },
  template: `
  <div class="w-full flex justify-end action-dropdown">
  <dropdown-button
    class="float-right"
  >
    <span
      slot="link"
      class="bg-white text-grey-500 h-10 flex items-center justify-between font-medium pl-3 pr-2 py-1 border border-grey-200 rounded-lg"
    >
      <span class="mr-3 pr-2 font-medium">
        {{ $t('frontend_groovemail_mail_lead_actions') }}
      </span>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="fill-current h-4 w-4">
        <path d="M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z"/>
      </svg>
      
    </span>
    <div
      slot="dropdown"
      class="bg-white shadow rounded border border-grey-300 overflow-hidden cursor-pointer"
    >
      <div
        class="no-underline block p-2 text-md font-normal bg-white"
        @click="getAction($event, 'view')"
      >
        {{ $t('frontend_view') }}
      </div>
      <div
        class="no-underline block p-2 text-md font-normal bg-white"
        @click="getAction($event, 'delete')"
      >
        {{ $t('frontend_delete') }}
      </div>
    </div>
  </dropdown-button>
</div>`
});
